import { Menu, List, Checkbox, Divider, Card, Button, Input, Form, Typography, Row, Col, Tag, Slider, message, Collapse, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { getCounter, filterAction, search } from "@/helpers/filterHelper";
import { useEffect, useState } from "react";
// EKLEME 1: İkon import (İsteğe bağlı, Ant Design ikonlarından)
import { DeleteOutlined } from '@ant-design/icons'; 

const { Panel } = Collapse;

// ... (ChangeSegmentIcon ve SearchIcon bileşenleri aynı kalacak, burayı atlıyorum) ...

// DEĞİŞİKLİK 1: FilterGroup bileşenine onClear prop'u ve temizle butonu mantığı eklendi
const FilterGroup = ({ title, items, onChange, filterListIndex, onClear }) => {
  const { t } = useTranslation();
  
  // Bu grupta en az bir tane seçili eleman var mı kontrolü
  const hasCheckedItems = items?.some(item => item.checked);

  return (
    <div>
      {/* Eğer seçili eleman varsa Temizle butonunu göster */}
      {hasCheckedItems && (
        <div className="flex justify-start text-center mb-2">
          <Button 
          style={{
            cursor:'pointer'
          }}
            onClick={() => onClear(filterListIndex)}
          >
           <div style={{alignItems:'center',justifyContent:'center',alignItems:'center'}}> {t('clear-filter') } </div>
          </Button>
        </div>
      )}
      
      {items?.map((item, index) => (
        <FilterItem 
          filterListIndex={filterListIndex} 
          filterItemIndex={index} 
          onChange={onChange} 
          item={item} 
          key={index} 
        />
      ))}
    </div>
  )
}


const FilterItem = ({ item, onChange, filterItemIndex, filterListIndex }) => {
  return (<div className={`flex p-[2px] ${filterItemIndex % 2 === 0 ? 'bg-[#f6f7f9]' : 'bg-white'} rounded-[4px]`}>
    <Checkbox onChange={(e) => onChange(filterItemIndex, filterListIndex, e.target.checked)} checked={item.checked} disabled={item.count == 0 ? true : false} />
    <div className={`flex w-full justify-between ml-[10px] text-[#565d6c]`}>
      <span>
        {item.Name}
      </span>
      <span>{item.count}</span>
    </div>
  </div>)
}

const Filter = ({ reducer, filterType }) => {
  const { t } = useTranslation()

  const filtersData = reducer.state.filtersData;
  const filterTree = reducer.state.filterTree;
  const originalProducts = reducer.state.originalProducts;

  const onChange = (filterItemIndex, filterListIndex, value) => {
    filtersData[filterListIndex].Items[filterItemIndex].checked = value
    reducer.dispatch({ type: 'setFiltersData', payload: filtersData })
    let x = filterAction(originalProducts, filtersData, filterTree, true);
    reducer.dispatch({ type: 'setProducts', payload: x })
    let b = getCounter(originalProducts, filtersData, filterTree)
    reducer.dispatch({ type: 'setFiltersData', payload: b })
  }

  // DEĞİŞİKLİK 2: Grup temizleme fonksiyonu
  const onClearGroup = (filterListIndex) => {
    // 1. Mevcut state referansını kopyala
    const newFiltersData = [...filtersData];
    
    // 2. İlgili gruptaki tüm itemların checked özelliğini false yap
    if (newFiltersData[filterListIndex] && newFiltersData[filterListIndex].Items) {
        newFiltersData[filterListIndex].Items.forEach(item => {
            item.checked = false;
        });
    }

    // 3. State'i güncelle
    reducer.dispatch({ type: 'setFiltersData', payload: newFiltersData });

    // 4. Ürünleri tekrar filtrele (hiçbir şey seçili değilmiş gibi o grup için)
    let filteredProducts = filterAction(originalProducts, newFiltersData, filterTree, true);
    reducer.dispatch({ type: 'setProducts', payload: filteredProducts });

    // 5. Sayaçları güncelle
    let newCounters = getCounter(originalProducts, newFiltersData, filterTree);
    reducer.dispatch({ type: 'setFiltersData', payload: newCounters });
  }

  const getName = (titleName) => {
    if (titleName === 'Product Group') {
      return t('product-groups');
    } else if (titleName === 'Brands') {
      return t('brands');
    } else {
      return titleName;
    }
  };

  return (
    <div>    
      <Switch
        checkedChildren={t('included-oem-products')}
        unCheckedChildren={t('included-oem-products')}
        onChange={(checked) => {
          reducer.dispatch({ type: 'setIncludedOEMProducts', payload: checked });
        }}
        checked={reducer?.state?.includedOEMProducts}
        style={{ marginBottom: '10px' }}
      />
      <Collapse style={{ borderRadius: '6px' }} defaultActiveKey={['0', '1']}>
        {filtersData.map((item, key) => (
          <Panel header={getName(item.Name)} key={key} style={{ borderRadius: '6px', color: '#565d6c', backgroundColor: '#f6f7f9' }}>
            {/* DEĞİŞİKLİK 3: onClear prop'u gönderildi */}
            <FilterGroup 
            
              filterType={filterType} 
              onChange={onChange} 
              onClear={onClearGroup} 
              filterListIndex={key} 
              reducer={reducer} 
              title={item.Name} 
              items={item.Items} 
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default Filter;